import {ParticleConfig} from '@specials/particle-emitter';

export const confettiAnimationConfig = (): ParticleConfig => ({
  lifeTime: {
    value: 5000,
  },
  speed: {
    start: 4,
    end: 1,
  },
  scale: {
    value: 0.75,
  },
  gravity: {
    value: 4.5,
    multiplier: {
      min: 0.8,
      max: 1.2,
    },
  },
  direction: {
    minAngle: 0,
    maxAngle: 360,
  },
});
